import React from 'react';
import { FormTextInput } from '../../../base-components/FormTextInput';
import commonStyles from './Registration.module.scss';
import styles from './RegistrationFirstStep.module.scss';

export const RegistrationFirstStep = () => {
    return (
        <div className={commonStyles.container}>
            <h3 className={commonStyles.sectionHeading}>
                Информация о лице, регистрирующем компанию
            </h3>

            <FormTextInput
                name="user.lastName"
                label="Фамилия"
                className={styles.lastName}
            />

            <FormTextInput
                name="user.firstName"
                label="Имя"
                className={styles.firstName}
            />

            <FormTextInput
                name="user.secondName"
                label="Отчество"
                className={styles.secondName}
            />

            <FormTextInput
                name="user.workPhone"
                label="Номер телефона"
                className={styles.workPhone}
            />

            <FormTextInput
                name="user.email"
                label="Email"
                className={styles.email}
            />

            <FormTextInput
                name="user.password"
                label="Придумайте пароль"
                type="password"
                className={styles.password}
            />
        </div>
    );
};
